import { render, staticRenderFns } from "./TableDeviceAccessGroups.vue?vue&type=template&id=12a52077"
import script from "./TableDeviceAccessGroups.vue?vue&type=script&lang=js"
export * from "./TableDeviceAccessGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports